package link.erpango.quip.ui.noteimport

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Checkbox
import androidx.compose.material.CheckboxDefaults
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.RadioButton
import androidx.compose.material.RadioButtonDefaults
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.material.TextButton
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Search
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import compose.icons.FontAwesomeIcons
import compose.icons.fontawesomeicons.Solid
import compose.icons.fontawesomeicons.solid.Magic
import kotlinx.coroutines.launch
import link.erpango.quip.domain.entities.DSparePartCatalog
import link.erpango.quip.domain.ocr.OcrError
import link.erpango.quip.domain.ocr.OcrNoteText
import link.erpango.quip.domain.noteimport.ImportDraft
import link.erpango.quip.domain.noteimport.MaintenanceDraft
import link.erpango.quip.domain.noteimport.NoteImportLimits
import link.erpango.quip.domain.noteimport.NoteImportTarget
import link.erpango.quip.domain.noteimport.SparePartDraft
import link.erpango.quip.domain.noteimport.VehicleDraft
import link.erpango.quip.domain.noteimport.localDateFromUtcMillis
import link.erpango.quip.features.noteimport.NoteAnalysisController
import link.erpango.quip.features.noteimport.NoteAnalysisState
import link.erpango.quip.features.noteimport.NoteImportAiMessage
import link.erpango.quip.features.noteimport.NoteImportSelection
import link.erpango.quip.features.noteimport.NoteImportUiState
import link.erpango.quip.features.noteimport.NoteImportViewModel
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.theme.QuipDimens
import link.erpango.quip.ui.components.QuipCard
import link.erpango.quip.ui.components.QuipDialogGeneric
import link.erpango.quip.ui.components.QuipPrimaryButton
import link.erpango.quip.ui.components.QuipSecondaryButton
import link.erpango.quip.ui.components.QuipTextBadge
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.ui.getSparePartCategoryString
import link.erpango.quip.ui.getSparePartTypeString
import link.erpango.quip.ui.ocr.CapturePhotoScreen
import link.erpango.quip.ui.ocr.PlatformImagePicker
import link.erpango.quip.ui.ocr.PlatformPhotoCapture
import link.erpango.quip.ui.ocr.PlatformTextRecognition
import link.erpango.quip.ui.ocr.ocrErrorMessage
import org.jetbrains.compose.resources.stringResource
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.cancel
import quip.composeapp.generated.resources.close
import quip.composeapp.generated.resources.note_import_ai_applied
import quip.composeapp.generated.resources.note_import_ai_consent_accept
import quip.composeapp.generated.resources.note_import_ai_consent_decline
import quip.composeapp.generated.resources.note_import_ai_consent_message
import quip.composeapp.generated.resources.note_import_ai_consent_title
import quip.composeapp.generated.resources.note_import_ai_loading
import quip.composeapp.generated.resources.note_import_ai_privacy
import quip.composeapp.generated.resources.note_import_ai_remaining
import quip.composeapp.generated.resources.note_import_already_in_garage
import quip.composeapp.generated.resources.note_import_analyze
import quip.composeapp.generated.resources.note_import_camera_action
import quip.composeapp.generated.resources.note_import_counter
import quip.composeapp.generated.resources.note_import_error_daily_quota
import quip.composeapp.generated.resources.note_import_error_failed
import quip.composeapp.generated.resources.note_import_error_generic
import quip.composeapp.generated.resources.note_import_error_global_quota
import quip.composeapp.generated.resources.note_import_error_network
import quip.composeapp.generated.resources.note_import_error_rate_limited
import quip.composeapp.generated.resources.note_import_error_timeout
import quip.composeapp.generated.resources.note_import_error_too_long
import quip.composeapp.generated.resources.note_import_error_unavailable
import quip.composeapp.generated.resources.note_import_hint
import quip.composeapp.generated.resources.note_import_import_all
import quip.composeapp.generated.resources.note_import_improve_ai
import quip.composeapp.generated.resources.note_import_intro
import quip.composeapp.generated.resources.note_import_no_results
import quip.composeapp.generated.resources.note_import_ocr_loading
import quip.composeapp.generated.resources.note_import_part_incomplete
import quip.composeapp.generated.resources.note_import_pick_image
import quip.composeapp.generated.resources.note_import_pick_maintenance
import quip.composeapp.generated.resources.note_import_pick_parts
import quip.composeapp.generated.resources.note_import_pick_spare_part
import quip.composeapp.generated.resources.note_import_pick_vehicle
import quip.composeapp.generated.resources.note_import_title
import quip.composeapp.generated.resources.note_import_truncated
import quip.composeapp.generated.resources.note_import_use_selection

/**
 * Full-screen dialog of the "Rellenar desde nota" assistant: paste a note, analyze it on the
 * device, optionally improve it with AI, pick a candidate and hand it back to the form.
 * Nothing is created here: [onApply] only fills the form, which the user still saves.
 */
@Composable
fun NoteImportDialog(
    viewModel: NoteImportViewModel,
    sparePartCatalog: DSparePartCatalog,
    onDismiss: () -> Unit,
    onApply: (NoteImportSelection) -> Unit,
    /** "Importar todo": hands the note and its result to the bulk import. Null hides it. */
    onImportAll: ((note: String, draft: ImportDraft) -> Unit)? = null,
) {
    val state by viewModel.uiState.collectAsState()
    val analysis = state.analysis
    val controller = viewModel.analysis

    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        Surface(modifier = Modifier.fillMaxSize().imePadding(), color = QuipColors.colorBackground) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(QuipDimens.padding8),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    IconButton(onClick = onDismiss) {
                        Icon(Icons.Default.Close, contentDescription = stringResource(Res.string.close), tint = QuipColors.colorText)
                    }
                    Text(
                        text = stringResource(Res.string.note_import_title),
                        style = MaterialTheme.typography.h6,
                        fontWeight = FontWeight.Bold,
                        color = QuipColors.colorText,
                    )
                }

                Column(
                    modifier = Modifier
                        .weight(1f)
                        .verticalScroll(rememberScrollState())
                        .padding(horizontal = QuipDimens.padding16),
                    verticalArrangement = Arrangement.spacedBy(QuipDimens.padding12),
                ) {
                    NoteInputSection(
                        analysis = analysis,
                        controller = controller,
                        intro = stringResource(Res.string.note_import_intro),
                    )

                    if (analysis.draft != null && !analysis.isAiLoading) {
                        Candidates(state, viewModel, sparePartCatalog)
                        val draft = analysis.draft
                        val total = draft.vehicles.size + draft.maintenances.size + draft.spareParts.size
                        // A note with more than one thing does not fit a single form: offer the bulk import.
                        if (onImportAll != null && total > 1) {
                            TextButton(onClick = { onImportAll(analysis.analyzedNote, draft) }) {
                                Text(
                                    text = stringResource(Res.string.note_import_import_all, total),
                                    color = QuipColors.colorPrimary,
                                    fontWeight = FontWeight.Bold,
                                )
                            }
                        }
                    }
                    Spacer(Modifier.height(QuipDimens.padding8))
                }

                if (state.draft != null && !analysis.isAiLoading) {
                    QuipPrimaryButton(
                        text = stringResource(Res.string.note_import_use_selection),
                        onClick = { viewModel.buildSelection()?.let(onApply) },
                        enabled = state.canApply,
                        modifier = Modifier.padding(QuipDimens.padding16),
                    )
                }
            }
        }
    }

}

/**
 * Paste box, "Analizar" and the AI option. Shared by the form dialog and the bulk import screen.
 */
@Composable
internal fun NoteInputSection(analysis: NoteAnalysisState, controller: NoteAnalysisController, intro: String) {
    val scope = rememberCoroutineScope()
    var isRecognizing by remember { mutableStateOf(false) }
    var ocrError by remember { mutableStateOf<OcrError?>(null) }
    var showCapture by remember { mutableStateOf(false) }

    // On-device OCR of the picked image: the recognized text only fills the editable field, the
    // user still decides when to analyze it.
    val imagePicker = PlatformImagePicker.rememberLauncher(
        onImagePicked = { bytes ->
            scope.launch {
                isRecognizing = true
                ocrError = null
                val result = PlatformTextRecognition.recognize(bytes)
                isRecognizing = false
                if (result.isSuccess) {
                    controller.onNoteChange(
                        OcrNoteText.merge(analysis.note, result.text, NoteImportLimits.MAX_NOTE_LENGTH)
                    )
                } else {
                    ocrError = result.error
                }
            }
        },
        onError = { ocrError = it },
    )

    Column(verticalArrangement = Arrangement.spacedBy(QuipDimens.padding12)) {
        Text(
            text = intro,
            style = MaterialTheme.typography.body2,
            color = QuipColors.colorTextSecondary,
        )
        QuipTextField(
            value = analysis.note,
            onValueChange = controller::onNoteChange,
            label = stringResource(Res.string.note_import_hint),
            minLines = 6,
            helperText = {
                Row(Modifier.fillMaxWidth().padding(horizontal = QuipDimens.padding16)) {
                    if (analysis.wasTruncated) {
                        Text(
                            text = stringResource(Res.string.note_import_truncated, NoteImportLimits.MAX_NOTE_LENGTH),
                            style = MaterialTheme.typography.caption,
                            color = QuipColors.colorWarning,
                            modifier = Modifier.weight(1f),
                        )
                    } else {
                        Spacer(Modifier.weight(1f))
                    }
                    Text(
                        text = stringResource(Res.string.note_import_counter, analysis.note.length, NoteImportLimits.MAX_NOTE_LENGTH),
                        style = MaterialTheme.typography.caption,
                        color = QuipColors.colorTextSecondary,
                    )
                }
            },
        )
        // Hidden on platforms without an image picker instead of showing a failing action.
        if (PlatformImagePicker.isSupported) {
            if (isRecognizing) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    CircularProgressIndicator(modifier = Modifier.size(QuipDimens.iconSize24), color = QuipColors.colorPrimary)
                    Spacer(Modifier.width(QuipDimens.padding12))
                    Text(
                        text = stringResource(Res.string.note_import_ocr_loading),
                        style = MaterialTheme.typography.body2,
                        color = QuipColors.colorText,
                        modifier = Modifier.weight(1f),
                    )
                }
            } else {
                QuipSecondaryButton(
                    text = stringResource(Res.string.note_import_pick_image),
                    onClick = imagePicker::launch,
                    enabled = !analysis.isAnalyzing && !analysis.isAiLoading,
                )
            }
        }
        ocrError?.let { error ->
            Text(
                text = ocrErrorMessage(error),
                style = MaterialTheme.typography.body2,
                color = QuipColors.colorError,
            )
        }
        // Hidden on platforms without a camera implementation instead of showing a failing action.
        if (PlatformPhotoCapture.isSupported && !isRecognizing) {
            QuipSecondaryButton(
                text = stringResource(Res.string.note_import_camera_action),
                onClick = { showCapture = true },
                enabled = !analysis.isAnalyzing && !analysis.isAiLoading,
            )
        }
        QuipPrimaryButton(
            text = stringResource(Res.string.note_import_analyze),
            onClick = controller::analyze,
            icon = Icons.Default.Search,
            enabled = analysis.note.isNotBlank() && !analysis.isAnalyzing && !analysis.isAiLoading,
        )
        AiSection(analysis, onRequestAi = controller::requestAi, onCancel = controller::cancelAi)
    }

    if (analysis.showConsent) {
        QuipDialogGeneric(
            title = stringResource(Res.string.note_import_ai_consent_title),
            message = stringResource(Res.string.note_import_ai_consent_message),
            confirmButtonText = stringResource(Res.string.note_import_ai_consent_accept),
            dismissButtonText = stringResource(Res.string.note_import_ai_consent_decline),
            onConfirm = { controller.onConsent(true) },
            onDismiss = { controller.onConsent(false) },
        )
    }

    // Camera capture recognises the photo on the device and merges it into the editable note.
    if (showCapture && PlatformPhotoCapture.isSupported) {
        CapturePhotoScreen(
            onTextRecognized = { text ->
                showCapture = false
                controller.onNoteChange(
                    OcrNoteText.merge(analysis.note, text, NoteImportLimits.MAX_NOTE_LENGTH)
                )
            },
            onDismiss = { showCapture = false },
        )
    }
}

@Composable
private fun AiSection(analysis: NoteAnalysisState, onRequestAi: () -> Unit, onCancel: () -> Unit) {
    if (analysis.isAiLoading) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            CircularProgressIndicator(modifier = Modifier.size(QuipDimens.iconSize24), color = QuipColors.colorPrimary)
            Spacer(Modifier.width(QuipDimens.padding12))
            Text(
                text = stringResource(Res.string.note_import_ai_loading),
                style = MaterialTheme.typography.body2,
                color = QuipColors.colorText,
                modifier = Modifier.weight(1f),
            )
            TextButton(onClick = onCancel) { Text(stringResource(Res.string.cancel), color = QuipColors.colorPrimary) }
        }
        return
    }
    if (analysis.aiAvailable) {
        val remaining = analysis.aiRemainingToday
        val label = stringResource(Res.string.note_import_improve_ai)
        QuipSecondaryButton(
            text = label,
            onClick = onRequestAi,
            icon = FontAwesomeIcons.Solid.Magic,
            enabled = analysis.canUseAi,
        )
        if (remaining != null && analysis.aiDailyLimit > 0) {
            Text(
                text = stringResource(Res.string.note_import_ai_remaining, remaining, analysis.aiDailyLimit),
                style = MaterialTheme.typography.caption,
                color = QuipColors.colorTextSecondary,
            )
        }
        Text(
            text = stringResource(Res.string.note_import_ai_privacy),
            style = MaterialTheme.typography.caption,
            color = QuipColors.colorTextSecondary,
        )
    }
    aiMessageText(analysis)?.let { message ->
        Text(text = message, style = MaterialTheme.typography.body2, color = QuipColors.colorError)
    }
    if (analysis.draft?.aiApplied == true) {
        QuipTextBadge(text = stringResource(Res.string.note_import_ai_applied))
    }
}

@Composable
private fun aiMessageText(analysis: NoteAnalysisState): String? = when (analysis.aiMessage) {
    null -> null
    NoteImportAiMessage.RATE_LIMITED ->
        if (analysis.aiCooldownSeconds > 0) stringResource(Res.string.note_import_error_rate_limited, analysis.aiCooldownSeconds) else null
    NoteImportAiMessage.DAILY_QUOTA -> stringResource(Res.string.note_import_error_daily_quota)
    NoteImportAiMessage.GLOBAL_QUOTA -> stringResource(Res.string.note_import_error_global_quota)
    NoteImportAiMessage.UNAVAILABLE -> stringResource(Res.string.note_import_error_unavailable)
    NoteImportAiMessage.TIMEOUT -> stringResource(Res.string.note_import_error_timeout)
    NoteImportAiMessage.FAILED -> stringResource(Res.string.note_import_error_failed)
    NoteImportAiMessage.NETWORK -> stringResource(Res.string.note_import_error_network)
    NoteImportAiMessage.TOO_LONG -> stringResource(Res.string.note_import_error_too_long)
    NoteImportAiMessage.GENERIC -> stringResource(Res.string.note_import_error_generic)
}

@Composable
private fun Candidates(state: NoteImportUiState, viewModel: NoteImportViewModel, catalog: DSparePartCatalog) {
    val draft = state.draft ?: return
    val hasCandidates = when (state.target) {
        NoteImportTarget.VEHICLE -> draft.vehicles.isNotEmpty()
        NoteImportTarget.MAINTENANCE -> draft.maintenances.isNotEmpty() || draft.spareParts.isNotEmpty()
        NoteImportTarget.SPARE_PART -> draft.spareParts.isNotEmpty()
        NoteImportTarget.BULK -> false
    }
    if (!hasCandidates) {
        Text(
            text = stringResource(Res.string.note_import_no_results),
            style = MaterialTheme.typography.body2,
            color = QuipColors.colorTextSecondary,
        )
        return
    }
    when (state.target) {
        NoteImportTarget.VEHICLE -> {
            SectionTitle(stringResource(Res.string.note_import_pick_vehicle))
            draft.vehicles.forEach { vehicle ->
                CandidateRow(
                    selected = vehicle.id == state.selectedVehicleId,
                    multiple = false,
                    onClick = { viewModel.selectVehicle(vehicle.id) },
                    title = vehicleTitle(vehicle),
                    subtitle = vehicleSubtitle(vehicle),
                    badge = if (vehicle.garageMatchVin != null) stringResource(Res.string.note_import_already_in_garage) else null,
                )
            }
        }

        NoteImportTarget.MAINTENANCE -> {
            val maintenances = state.maintenanceCandidates
            if (maintenances.isNotEmpty()) {
                SectionTitle(stringResource(Res.string.note_import_pick_maintenance))
                maintenances.forEach { maintenance ->
                    CandidateRow(
                        selected = maintenance.id == state.selectedMaintenanceId,
                        multiple = false,
                        onClick = { viewModel.selectMaintenance(maintenance.id) },
                        title = maintenance.description?.value ?: "—",
                        subtitle = maintenanceSubtitle(maintenance),
                    )
                }
            }
            if (draft.spareParts.isNotEmpty()) {
                SectionTitle(stringResource(Res.string.note_import_pick_parts))
                draft.spareParts.forEach { part ->
                    val complete = viewModel.isCompleteForMaintenance(part)
                    CandidateRow(
                        selected = part.id in state.selectedPartIds,
                        multiple = true,
                        enabled = complete,
                        onClick = { viewModel.togglePart(part.id) },
                        title = partTitle(part, catalog),
                        subtitle = if (complete) partSubtitle(part) else stringResource(Res.string.note_import_part_incomplete),
                    )
                }
            }
        }

        NoteImportTarget.SPARE_PART -> {
            SectionTitle(stringResource(Res.string.note_import_pick_spare_part))
            draft.spareParts.forEach { part ->
                CandidateRow(
                    selected = part.id in state.selectedPartIds,
                    multiple = false,
                    onClick = { viewModel.togglePart(part.id) },
                    title = partTitle(part, catalog),
                    subtitle = partSubtitle(part),
                )
            }
        }

        NoteImportTarget.BULK -> Unit
    }
}

@Composable
private fun SectionTitle(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.subtitle1,
        fontWeight = FontWeight.Bold,
        color = QuipColors.colorText,
        modifier = Modifier.padding(top = QuipDimens.padding8),
    )
}

@Composable
private fun CandidateRow(
    selected: Boolean,
    multiple: Boolean,
    onClick: () -> Unit,
    title: String,
    subtitle: String,
    badge: String? = null,
    enabled: Boolean = true,
) {
    QuipCard(modifier = Modifier.clickable(enabled = enabled, onClick = onClick), elevation = QuipDimens.padding2) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (multiple) {
                Checkbox(
                    checked = selected && enabled,
                    onCheckedChange = { onClick() },
                    enabled = enabled,
                    colors = CheckboxDefaults.colors(checkedColor = QuipColors.colorPrimary),
                )
            } else {
                RadioButton(
                    selected = selected,
                    onClick = onClick,
                    enabled = enabled,
                    colors = RadioButtonDefaults.colors(selectedColor = QuipColors.colorPrimary),
                )
            }
            Spacer(Modifier.width(QuipDimens.padding8))
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.body1,
                    fontWeight = FontWeight.Bold,
                    color = if (enabled) QuipColors.colorText else DisabledText,
                )
                if (subtitle.isNotBlank()) {
                    Text(
                        text = subtitle,
                        style = MaterialTheme.typography.caption,
                        color = if (enabled) QuipColors.colorTextSecondary else DisabledText,
                    )
                }
                badge?.let {
                    Spacer(Modifier.height(QuipDimens.padding4))
                    QuipTextBadge(text = it)
                }
            }
        }
    }
}

internal fun vehicleTitle(vehicle: VehicleDraft): String =
    listOfNotNull(vehicle.brand?.value, vehicle.model?.value, vehicle.year?.value?.toString())
        .joinToString(" ").ifBlank { vehicle.plate?.value ?: vehicle.vin?.value ?: "—" }

internal fun vehicleSubtitle(vehicle: VehicleDraft): String =
    listOfNotNull(vehicle.plate?.value, vehicle.vin?.value).joinToString(" · ")

internal fun maintenanceSubtitle(maintenance: MaintenanceDraft): String = listOfNotNull(
    maintenance.date?.value?.let { formatDate(it) } ?: maintenance.rawDate,
    maintenance.kilometers?.value?.let { "$it km" },
    maintenance.cost?.value?.let { "$it €" },
).joinToString(" · ")

@Composable
internal fun partTitle(part: SparePartDraft, catalog: DSparePartCatalog): String {
    val type = part.typeId?.value?.let { catalog.sparePartTypes[it] }
    return when {
        type != null -> getSparePartTypeString(type.translationKey)
        part.categoryId != null -> getSparePartCategoryString(catalog.categories[part.categoryId.value] ?: "")
        else -> part.phrase ?: "—"
    }
}

internal fun partSubtitle(part: SparePartDraft): String = listOfNotNull(
    part.brand?.value,
    part.model?.value,
    part.reference?.value?.let { "ref. $it" },
    part.quantity?.value?.let { quantity -> listOfNotNull(quantity.toString(), part.unit?.value).joinToString(" ") },
).joinToString(" · ")

internal fun formatDate(utcMillis: Long): String {
    val date = localDateFromUtcMillis(utcMillis)
    fun Int.twoDigits() = toString().padStart(2, '0')
    return "${date.day.twoDigits()}/${date.month.ordinal.plus(1).twoDigits()}/${date.year}"
}
